import React, { Component } from "react";
import PaymentService from "../services/payment.service";
import ParamsService from "../services/params.service";
import PaymentCustomerService from "../services/payment-customer.service";
import EventBus from "../common/EventBus";
import { Navigate }from "react-router-dom";
import ReactModal from 'react-modal';
import '../css/modal.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getDay, addDays, format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';
import axios from "axios";
import jwtDecode from "jwt-decode";
import logogaz from '../img/gaz.png';
import logoelec from '../img/elec.png';
import valide from '../img/check.png';
import etape from '../img/etape.png';
import logo from "../img/logo-ohm-Q.png";
import cb from "../img/cb.png";
import authHeader from "../services/auth-header";
import Progressbar from "../common/progress_bar";
import loading from "../img/loading.gif";
const tokentime = format(new Date(), "dd/MM/yyyy hh:mm:ss");
registerLocale('fr', fr);

const  cm = ParamsService.$_GET("cm");
const  from = ParamsService.$_GET("from");
const  check = ParamsService.$_GET("check");
var nbrEtal=1;
var amountDetteBackup=[-1,-1,-1];
var buckupContent = false;
const API_URL = process.env.REACT_APP_URL_API;
const USER_NAME_DEFAULT = process.env.REACT_APP_USER_NAME_DEFAULT;
const USER_PWD_DEFAULT = process.env.REACT_APP_USER_PWD_DEFAULT;

export default class Payment extends Component {

    blockRef0 = React.createRef();
    blockRef1 = React.createRef();
    constructor(props) {
        super(props);
        this.viewList = this.viewList.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.infoPayment = this.infoPayment.bind(this);
        this.payment = this.payment.bind(this);
        this.transfer = this.transfer.bind(this);
        this.showBloc = this.showBloc.bind(this);
        this.loginDefault = this.loginDefault.bind(this);
        this.getContractsCustomer = this.getContractsCustomer.bind(this);
        this.handleOptionChangeTypePayment = this.handleOptionChangeTypePayment.bind(this);
        this.handleOptionChangeMethodEtalement = this.handleOptionChangeMethodEtalement.bind(this);
        this.handleOptionChangeMethodPayment = this.handleOptionChangeMethodPayment.bind(this);
        this.handleOptionChangeNbrEtalement = this.handleOptionChangeNbrEtalement.bind(this);
        this.handleOptionChangeInfoEtalement = this.handleOptionChangeInfoEtalement.bind(this);
        this.onChangeAmountUpdate = this.onChangeAmountUpdate.bind(this);
        this.reload = this.reload.bind(this);
        this.handleSelectInvoice = this.handleSelectInvoice.bind(this);

        this.state = {
            displayBlock: false,
            block:"",
            loading:false,
            contracts: "",
            redirect: "",
            customer: "",
            isOpen: false,
            methodPayment: "",
            typePayment: "",
            typePaymentNv2: "",
            idDette:"",
            hostedTokenizationUrl:"",
            htmlContent:"",
            contract:null,
            dette:false,
            methodPaymentEtalement:"",
            nbrEtalement:1,
            firstDate:format(addDays(new Date(),7), "dd/MM/yyyy"),
            startDate:new Date(),
            messagerecovery:"",
            cm:"",
            user:"",
            token:"",
            processId:"",
            partialAmount:false,
            validePayment:"",
            refContract:"",
            indexDette:"",
            idDetteP:"",
            existDette:false,
            infoEtalement:"",
            parent:"",
            etape:0,
            nbMax:1,
            amountmaxupdate:"",
            amountUpdate:"",
            errorMsgUpdateAmount:"",
            valideMsgUpdateAmount:"",
            msgerrorurl:"",
            msgerrorcm:"",
            telContact:"",
            rechargePage:false,
            paymentType:false,
            backListInvoice:"",
            backListPayment:"",
            backPartialAmount:"",
            backupSpread:"",
            backupSpreadForceListAmount:"",
            backupSpreadForceListNbetal:"",
            backupSpreadForce:"",
            backupP0calc:"",
            listRefInvoiceAnticip:[],
            loadingAnticip:false
        };


    }

    handleSelectInvoice(event){
        var contentAnticipeJs = JSON.parse(this.state.contracts);
        var listRefInvoiceAnticipJs = this.state.listRefInvoiceAnticip;
        var dettes = event.target.dataset.dettes;

        this.setState({loadingAnticip:true});
        if(this.state.listRefInvoiceAnticip.includes(event.target.value)){
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 - event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs = listRefInvoiceAnticipJs.filter(item => item !== event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }else{
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 + event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs=listRefInvoiceAnticipJs.concat(event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7), firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        PaymentService.getInfoSpreadAnticipated(this.state.cm,
            contentAnticipeJs[event.target.dataset.contract].contractRef,
            contentAnticipeJs[event.target.dataset.contract].dunning.or,
            contentAnticipeJs[event.target.dataset.contract].dunning.invoice_list,
            listRefInvoiceAnticipJs, dettes).then(
            response => {
                contentAnticipeJs[event.target.dataset.contract].dunning.spread = response.data.spread;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_amount = response.data.spread_force_list_amount;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_nbetal = response.data.spread_force_list_nbetal;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force = response.data.spread_force;
                contentAnticipeJs[event.target.dataset.contract].dunning.p0calc = response.data.p0calc;
                contentAnticipeJs[event.target.dataset.contract].dunning.partialAmount =response.data.partialAmount;
                this.setState({ contracts: JSON.stringify(contentAnticipeJs) });
                this.setState({ contract: contentAnticipeJs[event.target.dataset.contract] });
                this.setState({loadingAnticip:false});
                //console.log(response.data.partialAmount);
            },
            error => {
                console.log(error.response);
            }
        );

    }

    onChangeAmountUpdate(e) {
        let value = e.target.value *1;
        let amountTotal = e.target.dataset.amounttotal*1;
        let amountMin = e.target.dataset.amountmin*1;
        let minval = Math.min(amountMin,amountTotal).toFixed(2);
        this.setState({
            errorMsgUpdateAmount: "",
            valideMsgUpdateAmount: "",
            nbrEtalement:0,
            amountUpdate:""
        });
        localStorage.setItem("nbrEtalement",0);

        // Expression régulière pour valider le format float
        const floatRegex = /^-?\d*(\.\d+)?$/;

        // Vérification de la validit

        if (!floatRegex.test(value)) {
            this.setState({
                errorMsgUpdateAmount: "la valeur doit être un nombre avec 2 décimales maximum."
            });
        }else{
            if(value<minval){
                this.setState({
                    errorMsgUpdateAmount: "le montant minimum est "+minval+" euros."
                });
            }else{
                if(value>amountTotal){
                    this.setState({
                        errorMsgUpdateAmount: "le montant maximum est "+amountTotal+" euros."
                    });
                }else {
                    this.setState({
                        partialAmount: value,
                        amountUpdate:value,
                        valideMsgUpdateAmount: "Vous resterez redevable de "+(amountTotal-value).toFixed(2)+" euros."
                    });
                    localStorage.setItem("partialAmount",value);

                }
            }
        }

    }
    viewList(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ parent: index.target.dataset.parent });
    }

    transfer(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({loading:true});
        PaymentCustomerService.addPaymentCustomer(
            this.state.customer,
            JSON.stringify(this.state.contract),
            this.state.partialAmount,
            this.state.processId,
            "CUSTOMER_"+from,
            this.state.firstDate,
            this.state.nbrEtalement,
            this.state.methodPayment,
            this.state.methodPaymentEtalement,
            "",
            "",
            "",
            "LINK_CUSTOMER",
            null,
            this.state.listRefInvoiceAnticip,
            "0",
            null
            ).then(
                response => {
                    if(response.data.url){
                        if(from==="EC"){
                            window.open(response.data.url, "_blank");
                            this.setState({loading:false});
                            this.setState({rechargePage:true});
                        }else{
                            window.location.replace(response.data.url);
                        }

                    }else{
                        this.setState({loading:false});
                        this.setState({msgerrorurl:"Notre partenaire de paiement a rencontré un léger problème. Veuillez réessayer dans quelques secondes."})
                    }

                },
                error => {
                    this.setState({loading:false});
                    this.setState({msgerrorurl:"Notre partenaire de paiement a rencontré un léger problème. Veuillez réessayer dans quelques secondes."})
                }
            );

    }
    payment(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        PaymentService.getIframeWorldline().then(
            response => {
                this.setState({
                    hostedTokenizationUrl: response.data.hostedTokenizationUrl,
                    hostedTokenizationId: response.data.hostedTokenizationId
                });
                localStorage.setItem("hostedTokenizationUrl", response.data.hostedTokenizationUrl);
                localStorage.setItem("API_URL", API_URL);
                localStorage.setItem("contract", JSON.stringify(this.state.contract));
                localStorage.setItem("customer", this.state.customer);
                localStorage.setItem("methodPaiment", this.state.methodPayment);
                localStorage.setItem("methodPaymentSpread", this.state.methodPaymentEtalement);
                localStorage.setItem("firstDate", this.state.firstDate);
                localStorage.setItem("processId", this.state.processId);
                localStorage.setItem("token", this.state.token);
                localStorage.setItem("nbrEtalement", this.state.nbrEtalement);
                localStorage.setItem("partialAmount", this.state.partialAmount);
                localStorage.setItem("listRefInvoiceAnticip", this.state.listRefInvoiceAnticip);

            },
            error => {
                this.setState({
                    contracts:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
        this.setState({ isOpen: true });


    }


    loginDefault(cm) {
        return axios
            .post(API_URL + "login_check", {
                "username":USER_NAME_DEFAULT,
                "password":USER_PWD_DEFAULT
            }, { mode: 'cors', credentials: 'include' })
            .then(response => {
                if (response.data.token) {
                    const token = response.data.token;
                    let user = [];
                    user = jwtDecode(token);
                    user['useremail'] = response.data.email;
                    user['userid'] =  response.data.user_id;
                    user['role'] = response.data.roles;
                    this.setState({
                        user:user,
                        token:token
                    });
                    localStorage.setItem("token",token);
                    localStorage.setItem("user", JSON.stringify(user));
                    this.setState({etape:this.state.etape+20});
                    this.getContractsCustomer(cm, token);
                }
            });
    }

    getContractsCustomer(cm, token) {
        return axios.get(
            API_URL + 'haugazel/contracts_customer/' + cm,
            { headers: {
                        Authorization: 'Bearer ' + token
                }
            })
            .then(response => {
                if (response.data && !response.data.error) {
                    const  contracts= JSON.stringify(response.data.contracts);
                    const  customer= JSON.stringify(response.data.customer);
                    const  messagerecovery= JSON.stringify(response.data.messagerecovery);
                    this.setState({
                        contracts:contracts,
                        customer:customer,
                        messagerecovery: messagerecovery,
                        etape:this.state.etape+70
                    })

                }else{
                    if(response.data.error){
                        this.setState({
                                msgerrorcm: response.data.error
                            }
                        )
                }
                }

                return response.data;
            });

    }


    showBloc(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        var contentAnticipe = JSON.parse(this.state.contracts);

        if(buckupContent===false){
            buckupContent = this.state.contracts;
        }



        if(index.target.dataset.type==="anticipe") {
            this.setState({paymentType: "anticipe"});
            this.setState({listRefInvoiceAnticip: contentAnticipe[index.target.dataset.contract].anticipated.refInvoice});
            if(amountDetteBackup[index.target.dataset.contract]===-1) {
                amountDetteBackup[index.target.dataset.contract] = contentAnticipe[index.target.dataset.contract].dunning.actif;
            }
            contentAnticipe[index.target.dataset.contract].dunning.actif = contentAnticipe[index.target.dataset.contract].anticipated.sumAmountInvoice;
            contentAnticipe[index.target.dataset.contract].dunning.invoice_list = contentAnticipe[index.target.dataset.contract].anticipated.invoice;
            contentAnticipe[index.target.dataset.contract].dunning.payment_list = [];
            contentAnticipe[index.target.dataset.contract].dunning.partialAmount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.partialAmount;

            contentAnticipe[index.target.dataset.contract].dunning.spread = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_amount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_amount;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_nbetal = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_nbetal;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force;
            contentAnticipe[index.target.dataset.contract].dunning.p0calc = contentAnticipe[index.target.dataset.contract].anticipated.infospread.p0calc;
            this.setState({ contracts: JSON.stringify(contentAnticipe) });
        }else{
            this.setState({paymentType: "dettes"});
            this.setState({listRefInvoiceAnticip: ""});
            this.setState({ contracts: buckupContent });
        }

        localStorage.setItem("VALIDE_PAYMENT","NOK");
        localStorage.setItem("pp1",0);
        this.setState({ indexDette: index.target.dataset.contract});
        this.setState({ idDette: index.target.dataset.id ,block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)});
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7),firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        this.setState({ contract: contentAnticipe[index.target.dataset.contract]});
        this.setState({ idDetteP: "" })
        this.setState({ displayBlock: true });
        PaymentService.startProcess(
            JSON.parse(this.state.contracts)[index.target.dataset.contract],
            this.state.customer,
            this.state.user["userid"],
            (ParamsService.$_GET("from")!=="" ? "CUSTOMER_"+ParamsService.$_GET("from") : "CUSTOMER"),
            0,
            "",
            index.target.dataset.type==="anticipe" ? 1 : 0
        ).then(
            response => {
                this.setState({processId:response.data})
            },
            error => {
                this.setState({
                    contracts:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.displayBlock) {
            this.scrollToBottom(this.state.block);
            this.setState({ displayBlock: false });
        }
    }

    handleOptionChangeInfoEtalement(e){
        nbrEtal = e.target.options[e.target.selectedIndex].dataset.nbrmax;
        this.setState({
            partialAmount:e.target.value,
            nbMax:e.target.options[e.target.selectedIndex].dataset.nbrmax
        });

        this.infoPayment(this.state.customer, this.state.contract, localStorage.getItem("nbrEtalement") ? localStorage.getItem("nbrEtalement") : 1 , e.target.value, format(this.state.startDate,"dd/MM/yyyy"), this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data)
                });

            });
    }

    handleOptionChangeTypePayment(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ typePayment: index.target.dataset.val });
        this.setState({ infoEtalement: "" });
        this.setState({ methodPayment: index.target.dataset.methodpayment });
        this.setState({ partialAmount: index.target.dataset.partialamount });

        if(index.target.dataset.val==="pic" || index.target.dataset.val==="picvir"){
            this.setState({ nbrEtalement: 0 });
            localStorage.setItem("nbrEtalement", 0);
        }else{
            this.setState({ nbrEtalement: 1 });
            localStorage.setItem("nbrEtalement", 1);
        }

        this.setState({ amountUpdate: "" });
        this.setState({ valideMsgUpdateAmount: "" });
        nbrEtal = index.target.dataset.nbretal;
        localStorage.setItem("partialAmount",index.target.dataset.partialamount);

    }
    handleOptionChangeNbrEtalement(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ nbrEtalement: index.target.value, parent:"" });
        localStorage.setItem("nbrEtalement", index.target.value);
        this.infoPayment(this.state.customer, this.state.contract, index.target.value, this.state.partialAmount, format(this.state.startDate,"dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data)
                });

            });
    }


    handleOptionChangeMethodEtalement(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ methodPaymentEtalement: index.target.dataset.val });

    }

    handleOptionChangeMethodPayment(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ methodPaymentEtalement: "" });
        this.setState({ methodPayment: index.target.dataset.methodpayment });
    }


    infoPayment(customer, contract, nbrEtallement, partialPayment, firstDateEtalement,listFilterInvoice){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        return axios.post(API_URL + "payment/info", {
            customer,
            contract,
            nbrEtallement,
            partialPayment,
            firstDateEtalement,
            listFilterInvoice
        },{ headers: authHeader() });
    }
    closePopup(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        /*
        if(localStorage.getItem("VALIDE_PAYMENT")==="OK"){
            this.setState({
                loading:true
            });
            let updateContacts = JSON.parse(this.state.contracts);
            this.setState({idDetteP:this.state.idDette});
            this.setState({idDette:-1});
            if(updateContacts[this.state.indexDette].dunning.actif-this.state.amountUpdate>=0) {
                OdooService.getContractsCustomer(this.state.cm).then(
                    () => {
                        this.setState({
                            successful: true,
                            nextPage: "/info_payment",
                            loading:false,
                            contracts: localStorage.getItem("contracts")
                        });
                        this.setState({isOpen:false});
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        this.setState({
                            loading: false,
                            message: resMessage
                        });
                    }
                );
            }
        }else{
            this.setState({isOpen:false});
        }
        */
        this.setState({isOpen:false});
        window.location.reload();

    }
    reload(){
        window.location.reload();
    }
    scrollToBottom = (block) => {
        block.current.scrollIntoView({ behavior: 'smooth' });
    };
    componentDidMount() {
        localStorage.removeItem("user");
        localStorage.removeItem("contracts");
        localStorage.removeItem("contract");
        localStorage.removeItem("customer");
        localStorage.setItem("tokentime", tokentime);
        buckupContent = false;
        if(!check || check*1===0){
            window.location.replace("/confirmation/&cm="+cm+"&from="+from);
        }

        if(cm){
            this.setState({cm: cm});
            this.loginDefault(cm);
            this.setState({telContact:(cm[0] + cm[1] === "CM" ? "09 70 70 21 25" : "01 76 49 78 88")});
        }

        this.setState({ partialAmount: false });
        this.setState({ validePayment: "NOK" });
        localStorage.setItem("nbrEtalement", 1);
        localStorage.setItem("origine","CUSTOMER");
        this.setState({idDetteP: ""});
        localStorage.setItem("firstDate", format(addDays(new Date(),7), "dd/MM/yyyy"));
    }


    render() {

        const handleDateChange = (date) => {
            this.setState({startDate: date, firstDate:format(date, "dd/MM/yyyy"), parent:""});
            localStorage.setItem("firstDate", format(date, "dd/MM/yyyy"));
            this.infoPayment(this.state.customer, this.state.contract, this.state.nbrEtalement, this.state.partialAmount, format(date, "dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
                response => {

                    this.setState({
                        infoEtalement: JSON.stringify(response.data)
                    });

                });
        };


        const isWeekday = (date) => {
            const day = getDay(date);
            return day !== 0 && day !== 6;
        };
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        let items  = [];
        if(this.state.contracts){
            items = JSON.parse(this.state.contracts);
        }
        let customer = "";
        if(this.state.customer){
            customer = JSON.parse(this.state.customer);
        }

        let infoEtalementTab = [];
        if(this.state.infoEtalement){
            infoEtalementTab = JSON.parse(this.state.infoEtalement);
        }


        if(this.state.msgerrorcm){
           return(
            <div className="col-md-12">
                <header className="jumbotron">
                    <h3>{this.state.msgerrorcm}.</h3>
                </header>
            </div>);
        }

        return (

            <div className="col-12">
                { (this.state.customer==="") &&
                    <header className="jumbotron">
                        <Progressbar bgcolor="#30ad71" progress={this.state.etape}  height={30} />
                    </header>
                }
                { (this.state.customer!=="") &&
                <header className="jumbotron">
                    <div className="circle-container circle-customer">
                        <div className="circle-text">
                            {customer.firstname[0] + customer.lastname[0]}
                        </div>
                    </div>
                    <span className="name">
                        { customer.firstname + " " + customer.lastname }
                    </span>
                    <div className="trait"></div>
                    <span className="cm">
                        {customer.refCustomer}
                    </span>
                </header>

                }
                { (this.state.contracts!=="") &&

                <div className="App">
                    <div className="col-12 info-text">
                        {(this.state.existDette===true) &&
                        <span>Vous êtes invité(e) à régulariser vos dettes.</span>
                        }
                    </div>
                    {items.map((val, key) => {
                        if(this.state.existDette===false && val.dunning.actif>0) {
                            this.setState({existDette: true});
                        }

                        return (
                            <div className="row row-payment"  key={val.id}>
                                <div className="col-12 block-info-payment" >
                                    <div className="col-12 info-payment">
                                        <div className="circle-container circle-contract">
                                            <div className="circle-text">
                                                <img className="logotypecontact" alt={"Type contrat"}
                                                     src={val.energyType==="EL" ? logoelec : (val.energyType==="NG" ? logogaz : logo)}/>
                                            </div>
                                        </div>

                                        <div className="info-contract">
                                            <h3>{val.contractRef}</h3>
                                            <ul>
                                                <li>
                                                    <span className="titre">Energie :</span> <span className="info"> {val.energyType==="EL" ? "Electricité" : (val.energyType==="NG" ? "GAZ Naturel" : val.energyType)}</span>
                                                </li>
                                                <li>
                                                    <span className="titre">Statut du contrat :</span><span className="info"> {val.status}</span>
                                                </li>
                                                <li>
                                                    <span className="titre">Adresse du point de livraison :</span><span className="info"> {val.adress}</span>
                                                </li>
                                                <li>
                                                    <span className="titre ">Dettes :</span>
                                                    <span className="info"> {amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif} &euro;</span>
                                                </li>
                                                {(val.dunning.paused>0)&&
                                                    <li>
                                                        <span className="titre">Dettes en pause :</span><span className="info"> {val.dunning.paused} &euro;</span>
                                                    </li>
                                                }

                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                { ((val.dunning.actif > 0 && amountDetteBackup[key]===-1) || amountDetteBackup[key]>0) &&
                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                        <div className="col-12 info-payment info-dette">
                                            <h3 className="import">Gérer les dettes</h3>
                                            <div className="info-contract">
                                                <span className="titre">Dettes actives :</span><span className="info import"> {amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif} &euro;</span>
                                            </div>
                                            <div className="info-btn">
                                                <button data-id={val.id} data-contract={key} onClick={this.showBloc} className="btn-dette">Régulariser votre situation</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                { (val.anticipated.sumAmountInvoice > 0) &&
                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                        <div className="col-12 info-payment info-dette">
                                            <h3  className="import">Paiement de vos factures en cours</h3>
                                            <div className="info-contract">
                                                <span className="titre">Montant :</span><span className="info import"> {val.anticipated.sumAmountInvoice} &euro;</span><br/>
                                            </div>
                                            <div className="info-btn tooltipanticipe">
                                                <button  data-type="anticipe" id={"bloc"+val.id} data-id={val.id} data-contract={key} onClick={this.showBloc} className="btn-dette">Anticiper et trouver une solution</button>
                                                <span className="tooltiptextanticipe col-12">{"Vous pouvez payer vos factures à venir, par carte bancaire ou directement avec votre banque. Si le montant est important vous pouvez mettre en place un étalement dès aujourd’hui. Si la totalité du montant dû n’est ni payée, ni étalée, alors elle sera prélevée à la date d'échéance comme convenu."}</span>
                                            </div>
                                        </div>

                                    </div>
                                }

                                { (val.dunning.actif <=0 && val.anticipated.sumAmountInvoice<=0) &&
                                    <div className="col-12 block-info-payment">
                                        <div className="col-12 info-payment">
                                            <span><b>Tout a l’air en ordre, si vous rencontrez un problème contactez notre service client par téléphone au {this.state.telContact} ou sur internet : </b></span><a href="https://espace-client.ohm-energie.com/">Espace Client</a>
                                        </div>
                                    </div>
                                }

                                { (this.state.idDetteP*1===val.id*1) &&
                                    <div className="col-12 block-info-payment" >
                                        <div className="col-12 info-payment color-ohm block-valide-customer">
                                            <h3>Dettes payées avec succès. </h3>
                                        </div>
                                    </div>
                                }

                                { (val.id*1===this.state.idDette*1) &&
                                    <div id={val.id} className="col-12 info-payment info-dette info-dette-active" >
                                        <h3>{this.state.paymentType==="dettes" ? "Liste des éléments en dettes actives" : "Liste des factures à venir"}</h3>
                                        <div className="info-contract">
                                            <div className="dette-active">
                                                <span>{this.state.paymentType==="dettes" ? "Dettes actives" : "Total sélectionné"} :</span><span className="import"> {val.dunning.actif} &euro;</span>
                                            </div>
                                            <div className="info-table">
                                                {
                                                    ( this.state.paymentType!=="dettes")&&
                                                    <div>
                                                        {
                                                            this.state.loadingAnticip===true &&
                                                            <img className="loading" alt={"loading"} src={loading}/>
                                                        }

                                                    </div>
                                                }
                                            <table className="table">
                                                { this.state.paymentType==="dettes" &&
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Type</th>
                                                        <th scope="col">Nom</th>
                                                        <th scope="col">Date</th>
                                                        <th scope="col">Montant</th>
                                                    </tr>
                                                </thead>
                                                }

                                                { this.state.paymentType!=="dettes" &&
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">Numéro de facture</th>
                                                        <th scope="col">Date de facture</th>
                                                        <th scope="col">Date d'échéance</th>
                                                        <th scope="col">Montant</th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    </thead>
                                                }
                                                <tbody>
                                                {   val.dunning.payment_list &&
                                                    val.dunning.payment_list.map((payment, index) =>
                                                        <tr  key={index}>
                                                            <td>Paiement</td>
                                                            <td>{payment.name}</td>
                                                            <td>{payment.date}</td>
                                                            <td>{payment.residual_amount_debt} &euro;</td>
                                                        </tr>
                                                    )

                                                }

                                                {
                                                    val.dunning.invoice_list && this.state.paymentType==="dettes" &&
                                                    val.dunning.invoice_list.map((invoice, index) =>
                                                        <tr  key={index}>
                                                            <td>Facture</td>
                                                            <td>{invoice.invoice_number}</td>
                                                            <td>{invoice.invoice_date}</td>
                                                            <td>{invoice.residual_amount_debt} &euro;</td>
                                                        </tr>
                                                    )

                                                }
                                                {

                                                    val.dunning.invoice_list && this.state.paymentType!=="dettes"&&
                                                    val.dunning.invoice_list.map((invoice, index) =>
                                                        <tr  key={index}>
                                                            <td>{invoice.invoice_number}</td>
                                                            <td>{invoice.invoice_date}</td>
                                                            <td>{invoice.invoice_date_due}</td>
                                                            <td>{invoice.residual_amount_debt} &euro;</td>
                                                            <td><input
                                                                value={invoice.invoice_number}
                                                                data-amount={invoice.residual_amount_debt}
                                                                data-dettes={amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif}
                                                                data-contract = {key}
                                                                type="checkbox"
                                                                checked={this.state.listRefInvoiceAnticip.includes(invoice.invoice_number) ? true : false}
                                                                onChange={this.handleSelectInvoice}
                                                            /></td>
                                                        </tr>
                                                    )

                                                }
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        <div className="info-contract">
                                            <div className="method-payment">
                                                <div className="select-paiement">
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Comment souhaitez-vous régler {this.state.paymentType==="dettes" ? "vos dettes en cours" : "vos factures" } ?
                                                 </span>
                                                </div>
                                            <div className="form-check">
                                                <div className="row option-payment">
                                                    <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info " + (this.state.typePayment === "pic" ? "valid-option" : "")}
                                                         data-val="pic"
                                                         data-partialamount={val.dunning.actif}
                                                         data-amountmaxupdate={val.dunning.actif}
                                                         onClick={this.handleOptionChangeTypePayment}
                                                    >
                                                        {  (this.state.typePayment === "pic") &&
                                                            <div onClick={this.handleOptionChangeTypePayment}
                                                                 data-val="pic"
                                                                 data-partialamount={val.dunning.actif}
                                                                 data-amountmaxupdate={val.dunning.actif}
                                                                 className="col-12 option-payment-valid">
                                                                <img src={valide} alt="valide" />
                                                            </div>
                                                        }
                                                        <div className="col-12" data-methodpayment="piccb"
                                                             data-val="pic"
                                                             data-partialamount={val.dunning.actif}
                                                             data-amountmaxupdate={val.dunning.actif}
                                                             onClick={this.handleOptionChangeTypePayment}>
                                                        <span
                                                            data-val="pic"
                                                            data-partialamount={val.dunning.actif}
                                                            data-amountmaxupdate={val.dunning.actif}
                                                            onClick={this.handleOptionChangeTypePayment}
                                                        >Je préfère opter pour un</span>
                                                        <span className="option-payment-span"
                                                              data-val="pic"
                                                              data-partialamount={val.dunning.actif}
                                                              data-amountmaxupdate={val.dunning.actif}
                                                              onClick={this.handleOptionChangeTypePayment}
                                                        ><br/> {val.status ==="Actif" ? "paiement instantané complet" : "paiement instantané"}</span>
                                                        </div>
                                                    </div>
                                                    { val.dunning.spread.afficheEtalement===true &&
                                                    <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info " + (this.state.typePayment === "pipe" ? "valid-option" : "")}
                                                         data-partialamount={val.dunning.partialAmount}
                                                         data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                         data-val="pipe"
                                                         onClick={this.handleOptionChangeTypePayment}
                                                    >
                                                        {  (this.state.typePayment === "pipe") &&
                                                            <div data-partialamount={val.dunning.partialAmount}
                                                                 data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                 data-val="pipe"
                                                                 onClick={this.handleOptionChangeTypePayment}
                                                                 className="option-payment-valid col-12">
                                                                <img src={valide} alt="valide" />
                                                            </div>
                                                        }
                                                        <div data-partialamount={val.dunning.partialAmount}
                                                             data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                             data-val="pipe"
                                                             onClick={this.handleOptionChangeTypePayment}
                                                             className="col-12">
                                                        <span
                                                            data-partialamount={val.dunning.partialAmount}
                                                            data-val="pipe"
                                                            data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                            onClick={this.handleOptionChangeTypePayment}
                                                        >Je préfère opter pour un</span>
                                                        <span className="option-payment-span"
                                                              data-partialamount={val.dunning.partialAmount}
                                                              data-val="pipe"
                                                              data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                              onClick={this.handleOptionChangeTypePayment}
                                                        > <br/> paiement partiel immédiat <br/>et planifier l'étalement</span>
                                                        </div>
                                                    </div>
                                                    }

                                                </div>
                                            </div>
                                                { this.state.typePayment==="pic" &&
                                                    <>
                                                        {val.status !=="Actif" &&
                                                            <>
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement instantané
                                                </span>
                                                                <div className={"row option-payment info-amount-update col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info valid-option"}>
                                                                    <div className=" col-lg-4 col-md-12 col-sm-12">
                                                                        <label className="montant-partiel" htmlFor="montant">Montant</label>
                                                                    </div>
                                                                    <div className="row col-lg-7 col-md-12 col-sm-12 input-amount-div">
                                                                        <input
                                                                        type="text"
                                                                        className="form-control input-amount col-9"
                                                                        name="montant"
                                                                        data-amounttotal={val.dunning.actif}
                                                                        data-amountmin={val.dunning.spread.ct_ter_mt_min}
                                                                        defaultValue={val.dunning.actif}
                                                                        onChange={this.onChangeAmountUpdate}
                                                                        /> <span className="devis-input-amount"> &euro;</span>
                                                                    </div>
                                                                </div>
                                                                {this.state.errorMsgUpdateAmount &&
                                                                    <div className="alert alert-danger" role="alert">
                                                                        {this.state.errorMsgUpdateAmount}
                                                                    </div>
                                                                }
                                                                {this.state.valideMsgUpdateAmount &&
                                                                    <div className="alert alert-success" role="alert">
                                                                        {this.state.valideMsgUpdateAmount}
                                                                    </div>
                                                                }
                                                            </>
                                                        }
                                                        { (this.state.errorMsgUpdateAmount==="")&&
                                                            <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Moyens de paiement
                                                </span>
                                                        }

                                                    </>
                                                }
                                                { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe")&&
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement instantané
                                                </span>
                                                }
                                                { (val.dunning.partialAmount>0)&&
                                                    (this.state.typePayment==="pipe") &&
                                                    <div className="form-check">
                                                        <div className="row" id="pip">
                                                            <label className="montant-partiel col-lg-4 col-md-12 col-sm-12"><b>Montant du paiement instantané :</b></label>
                                                            <div className="col-lg-2 col-md-12 col-sm-12 ">
                                                                <select className="form-control info-montant-partiel" onChange={this.handleOptionChangeInfoEtalement}>
                                                                {   val.dunning.spread_force &&
                                                                    val.dunning.spread_force.map((elt, index) =>
                                                                        <option  data-nbrmax={elt.nb_max}
                                                                                 value={elt.amount}
                                                                                 selected={elt.amount===val.dunning.partialAmount ? true : ""}  key={index}>{elt.amount} &euro;</option>
                                                                    )

                                                                }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                }
                                                { ((this.state.typePayment === "pic" || this.state.typePayment==="pipe") && (this.state.errorMsgUpdateAmount==="")) &&
                                                    <div className={"form-check "}>
                                                        <div className={"option-payment row"}>
                                                            <div  className={"col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info "+ ((this.state.methodPayment === "piccb" || this.state.methodPayment === "pipcb") ? "valid-option" : "")}
                                                                  data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                  onClick={this.handleOptionChangeMethodPayment}>
                                                                {(this.state.methodPayment==="piccb" || this.state.methodPayment==="pipcb") &&
                                                                    <div className="option-payment-valid col-12"
                                                                         data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                    >
                                                                        <img src={valide} alt="valide"
                                                                             data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                             onClick={this.handleOptionChangeMethodPayment}/>
                                                                    </div>
                                                                }
                                                                <div className="col-12 moyen-payment"
                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                     onClick={this.handleOptionChangeMethodPayment}>
                                                                <div
                                                                    data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                    onClick={this.handleOptionChangeMethodPayment}
                                                                >
                                                                    <span
                                                                        data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                        onClick={this.handleOptionChangeMethodPayment}
                                                                    >Paiement par<br/></span>
                                                                    <span className="option-payment-span"
                                                                          data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                          onClick={this.handleOptionChangeMethodPayment}
                                                                    >Carte bancaire</span>
                                                                </div>
                                                                <div className="moyen-payment-cb"
                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                     onClick={this.handleOptionChangeMethodPayment}>
                                                                    <img className="logocb" alt={"CB"} src={cb}
                                                                         data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                    />
                                                                </div>
                                                                </div>
                                                            </div>
                                                            { (val.dunning.spread.prelemvementAuto===true || (val.dunning.spread.prelemvementAutoAnticipe && this.state.paymentType==='anticipe') || this.state.typePayment === "pic") &&
                                                                <div className={"col-lg-4 tooltippis col-md-12 col-sm-12 option-payment-2 option-payment-info "+ ((this.state.methodPayment === "picvir" || this.state.methodPayment === "pipvir") ? "valid-option" : "")}
                                                                     data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                     onClick={this.handleOptionChangeMethodPayment}
                                                                >
                                                                    { (this.state.methodPayment==="picvir" || this.state.methodPayment==="pipvir") &&
                                                                        <div className="option-payment-valid col-12"
                                                                             data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                             onClick={this.handleOptionChangeMethodPayment}>
                                                                            <img src={valide} alt="valide"
                                                                                 data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                 onClick={this.handleOptionChangeMethodPayment}/>
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 moyen-payment"
                                                                        data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                        onClick={this.handleOptionChangeMethodPayment}
                                                                    >
                                                                        <div
                                                                            data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                            onClick={this.handleOptionChangeMethodPayment}>
                                                                            <span
                                                                                data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                onClick={this.handleOptionChangeMethodPayment}
                                                                                >Payer avec ma banque<br/>

                                                                            </span>
                                                                            <span className="option-payment-span"
                                                                                  data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                  onClick={this.handleOptionChangeMethodPayment}>Simple, rapide et sécurisé
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <span className="tooltiptext">{"Payez directement depuis votre application bancaire avec notre partenaire Slimpay."}</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }

                                                { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe" && (this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") )&&
                                                    <>
                                                    <span>
                                                        <img src={etape} alt="valide" className="etape-option-payment"/>
                                                        Paramètres de l'étalement
                                                    </span>
                                                        <div className="form-check">
                                                            <div className="row">
                                                                { val.dunning.spread.prelemvementAuto===true &&
                                                                    <div onClick={this.handleOptionChangeMethodEtalement} data-val="sdd" className={"option-payment-1 col-lg-4 col-md-12 col-sm-12 option-payment-info "+(this.state.methodPaymentEtalement==="sdd" ? "valid-option" : "")}>
                                                                        { this.state.methodPaymentEtalement==="sdd" &&
                                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="sdd"
                                                                                 className="option-payment-valid col-12">
                                                                                <img src={valide} alt="valide" />
                                                                            </div>
                                                                        }
                                                                        <div className="col-12 moyen-payment" onClick={this.handleOptionChangeMethodEtalement}  data-val="sdd">
                                                                            <span data-val="sdd">Prélèvement automatique</span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {(this.state.methodPayment!=="picvir" && this.state.methodPayment!=="pipvir" )&&
                                                                    <div data-val="cb"
                                                                         onClick={this.handleOptionChangeMethodEtalement}
                                                                         className={"col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info "+(this.state.methodPaymentEtalement==="cb" ? "valid-option" : "")}>
                                                                        { this.state.methodPaymentEtalement==="cb" &&
                                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="cb"
                                                                                 className="col-12 option-payment-valid">
                                                                                <img src={valide} alt="valide" />
                                                                            </div>
                                                                        }
                                                                        <div onClick={this.handleOptionChangeMethodEtalement}  data-val="cb"
                                                                             className="col-12 moyen-payment ">
                                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="cb">
                                                                                <span data-val="cb">Paiement par<br/></span>
                                                                                <span data-val="cb" className="option-payment-span">Carte bancaire</span>
                                                                            </div>
                                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="cb" className="moyen-payment-cb">
                                                                                <img data-val="cb" className="logocb" alt={"CB"} src={cb}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                { (val.dunning.partialAmount>0 && this.state.methodPaymentEtalement!=="")&&
                                                <div className="form-check">
                                                { (this.state.typePayment==="pipe") &&
                                                    <div className="form-check" id="pip">
                                                        <div className="row">
                                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                                        <label className="form-check-label">
                                                            Nombre d’étalements
                                                        </label>
                                                        <select
                                                            onChange={this.handleOptionChangeNbrEtalement}
                                                            className="form-control col-12">
                                                            {function() {
                                                                let options = []
                                                                for (let i = 1; i<=nbrEtal; i++){
                                                                    options.push(<option value={i}>{i}</option>)
                                                                }
                                                                return options
                                                            }()
                                                            }
                                                        </select>
                                                        </div>
                                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                                        <label className="form-check-label">
                                                            Date du premier prélèvement
                                                        </label>

                                                        <DatePicker
                                                            selected={this.state.startDate}
                                                            onChange={handleDateChange}
                                                            dateFormat="dd/MM/yyyy"
                                                            required
                                                            className="form-control col-12"
                                                            placeholderText="dd/mm/yyyy"
                                                            filterDate={isWeekday}
                                                            minDate={addDays(new Date(), 1)}
                                                            maxDate={addDays(new Date(), this.state.paymentType === "dettes" ? val.dunning.spread.nbrDayMax : val.dunning.spread.nbrDayMaxAnticipe)}
                                                            locale="fr"
                                                        />
                                                        </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            }

                                            </div>
                                            { infoEtalementTab && this.state.infoEtalement && this.state.methodPaymentEtalement!=="" &&
                                                <div className="info-table-etalement">
                                                    <table className="table">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">Date du prélèvement</th>
                                                            <th scope="col">Montant prélevé total</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {   infoEtalementTab &&
                                                            infoEtalementTab.map((payment, index) =>
                                                                (payment.parent===this.state.parent ||  payment.name==='total')?
                                                                <tr className ={payment.name==='total' ? "tr-total" : "tr-detail"} key={index}>

                                                                    <td>{
                                                                        payment.name==='total' ?
                                                                            <span>{payment.datepayment} {payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "(Aujourd'hui)" : ""}</span>
                                                                            : payment.name
                                                                    }</td>
                                                                    <td>{payment.name==='total' ? <span>{payment.amount} &euro;</span> : <span>{payment.amount} &euro;</span>} </td>
                                                                    <td>{payment.name==='total' ? <button data-parent={payment.parent} onClick={this.viewList}>+</button> : ""} </td>
                                                                </tr> : ""
                                                            )

                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                            <div id="btn-payment">
                                                { (((this.state.methodPayment==="piccb" || this.state.methodPayment==="picvir") || ((this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") && this.state.methodPaymentEtalement!=="")) && (this.state.errorMsgUpdateAmount==="")) &&
                                                    <>{
                                                    (this.state.methodPayment==="piccb" || this.state.methodPayment==="pipcb")&&
                                                    <button onClick={this.payment} className="ohm-btn-payment btn btn-customer-payment">Procéder au paiement</button>
                                                    }
                                                    {
                                                    (this.state.methodPayment==="picvir" || this.state.methodPayment==="pipvir")&&
                                                        <>
                                                            {this.state.rechargePage===false &&
                                                                <button onClick={this.transfer} className="ohm-btn-payment btn btn-customer-payment">Procéder au paiement</button>
                                                            }
                                                            {this.state.rechargePage===true &&
                                                                <button onClick={this.reload} className="ohm-btn-payment btn btn-customer-payment">Actualiser la page</button>
                                                            }
                                                        </>
                                                    }
                                                    {this.state.loading===true &&
                                                        <div className="col-12">
                                                            <img className="loading" alt={"loading"}
                                                                 src={loading}/>
                                                        </div>
                                                    }
                                                    {this.state.msgerrorurl!=="" &&
                                                        <div className="msgerrorurl alert alert-danger" role="alert">
                                                            {this.state.msgerrorurl}
                                                        </div>
                                                    }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div ref={key===0 ? this.blockRef0 : this.blockRef1}></div>

                            </div>
                        )
                    })
                    }

                    <ReactModal
                        isOpen={this.state.isOpen}
                        contentLabel="Modal info carte"
                        className="custom-modal"
                    >
                        <div id="modal" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopup} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>
                            {this.state.loading===true &&
                            <div>
                                <img className="loading" alt={"loading"} src={loading}/>
                            </div>
                            }
                            <iframe  id="iframeWorldline" title={"Iframe Worldline"} src={"../iframeFile/iframecm.html?hostedTokenizationUrl="+this.state.hostedTokenizationUrl} allowFullScreen>
                            </iframe>

                        </div>

                    </ReactModal>

                </div>
                }
            </div>


        );

    }

}
